module.exports = __webpack_public_path__ + "img/full2-min.992d28ee.png";